// extracted by mini-css-extract-plugin
export default {"root":"register_root__jHupa","App":"register_App__w2OKV","register":"register_register__TkWEm","register-wrapper":"register_register-wrapper__uwG7y"};